<template>
  <div id = "partners">
    <b-loading :is-full-page="fullPage" :active.sync="getLoadingPartners"></b-loading>
    <div v-for="(partnerType, index) in getPartners" :key="index" class = "partner-type">
        <h2>{{$t(partnerType.name)}}</h2>
        <div class="partners-list">
          <div class="partner-container" v-for="(partner, index) in partnerType.content" :key="index">
            <a class="partner" :href="partner.link">
              <img :src="partner.logo" :alt="partner.name">
            </a>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  export default {
    data () {
      return {
        fullPage: true
      }
    },
    computed: {
        ...mapGetters('partnersModule', ['getPartners', 'getLoadingPartners'])
    },
    methods: {
        ...mapActions('partnersModule', ['requestPartners'])
    },
    mounted() {
        this.requestPartners();
    }
  }
</script>

<style scoped lang="scss">
#partners {
  @extend %eestec-page;
}
.partner-type {
  margin: auto;
  width: 80%;
}

.partner-row img{
  height: 100%;
}

h2 {
  display: block;
  font-weight: bold;
  font-size:  5vh;
  letter-spacing: 1px;
  text-align: center;
  margin-top: 50px;
}

.partners-list{
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  align-items: center;
}
.partner{
  margin: 0.5em 0.75em;
}

@media screen and (max-width: 600px) {
  .partner-container {
    margin-top: 20px;
  }
}

.partner > img {
  filter: grayscale(100%);
  opacity: 0.66;
  transition: all 0.3s ease;
  max-height:6vh;
}

.partner > img:hover{
  filter: grayscale(0%);
  opacity: 1;
}

.partner-type:first-child img {
  max-height: 10vh;
}

.partner-type:first-child .partner-container:nth-child(2) img {
  max-height: 6vh;
}

.partner-type:nth-child(2) img {
  max-height: 10vh;
}

.partner-type:nth-child(2) .partner-container:nth-child(3) img {
  max-height: 11.5vh;
}

.partner-type:nth-child(3) img {
  height: 8vh;
}

.partner-type:nth-child(4) img {
  max-height: 13vh;
}

.partner-type:nth-child(5) img {
  max-height: 12vh;
}

.partner-type:nth-child(5) .partner-container:first-child img {
  max-height: 15vh;
}

.partner-type:nth-child(6) .partner-container:nth-child(2) img {
  max-height: 10vh;
}

.partner-type:nth-child(6) .partner-container:nth-child(3) img {
  max-height: 10vh;
}

.partner-type:nth-child(7) img {
  max-height: 10vh;
}
</style>